import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Input } from 'widget/components';
import { useWidgetContext } from 'widget/widget-context';

const Email = () => {
  const { widget } = useWidgetContext();

  const [field, meta, helpers] = useField<string>('email');
  const { t } = useTranslation();

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      isValid={isValid}
      onChange={helpers.setValue}
      placeholder={`${t`Email`}${widget.is_email ? '*' : ''}`}
      style={{ marginBottom: 16 }}
      type="email"
    />
  );
};

export default Email;
